import { render } from "./addCategory.vue?vue&type=template&id=eee760ca"
import script from "./addCategory.vue?vue&type=script&lang=js"
export * from "./addCategory.vue?vue&type=script&lang=js"

import "./addCategory.vue?vue&type=style&index=0&id=eee760ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__